import { getFieldSelectOptionsByKeyword } from 'app/admin/services/ChangeLogDEServices';
import withInputErrorMessage from '../withInputErrorMessage';
import remoteOptionSelectFactory from './remoteOptionSelectFactory';
import withSelectFormik from './withSelectFormik';

export const AuditFieldSelectBase = remoteOptionSelectFactory({
   getSuggestionsPromise: getFieldSelectOptionsByKeyword,
});

export default withSelectFormik(withInputErrorMessage(AuditFieldSelectBase));
